import React from 'react';
import Layout from '@components/Layout/Layout';
import FlowForm from '@components/Flow/FlowForm/FlowForm';

const View = ({ data: { loading, offer, showAlert }, stream, handleSubmit }) => (
  <Layout title={stream.title}>
    <Layout.Col>
      <FlowForm
        loading={loading}
        offer={offer}
        stream={stream}
        onSubmit={handleSubmit}
        showAlert={showAlert}
      />
    </Layout.Col>
  </Layout>
);

export default View;
